import { createContext } from 'react'

export interface ClockContextValue {
  /** Current effective time (override if set, otherwise live). */
  now: Date
  /** The active override, or null when running on live time. */
  override: Date | null
  /** Set the override, or pass null to return to live time. */
  setOverride: (date: Date | null) => void
  /** Whether the fast-forward simulation is running (5 min / real sec). */
  simulating: boolean
  /** Start/stop the fast-forward simulation. */
  setSimulating: (on: boolean) => void
}

export const ClockContext = createContext<ClockContextValue>({
  now: new Date(0),
  override: null,
  setOverride: () => {},
  simulating: false,
  setSimulating: () => {},
})

/** The clock's write half. Never changes identity, so a component that sets the
 *  clock without displaying it doesn't re-render per tick (#289). */
export interface ClockControls {
  setOverride: (date: Date | null) => void
  setSimulating: (on: boolean) => void
}

export const ClockControlsContext = createContext<ClockControls>({
  setOverride: () => {},
  setSimulating: () => {},
})
